(() => {
  const section = document.getElementById('saleIntro');
  const stage = section?.querySelector('.sale-intro__stage');
  const frame = document.getElementById('saleIntroFrame');
  const attachedTab = document.getElementById('saleIntroAttachedTab');
  const landing = document.getElementById('saleTicketLanding');
  const carousel = landing?.querySelector('.body-gallery');
  const ticketSlot = carousel?.querySelector('.body-gallery__ticket-slot');
  const tearTab = document.getElementById('saleIntroTearTab');
  const ticketOverview = tearTab?.querySelector('.sale-intro__ticket-overview');
  const ripGlow = document.getElementById('saleIntroRipGlow');
  const mobileTicket = section?.querySelector('.sale-intro__mobile-ticket');
  const mobileFrame = section?.querySelector('.sale-intro__mobile-frame');
  const mobileRipCut = section?.querySelector('.sale-intro__mobile-rip-cut');
  if (!section || !stage || !frame || !attachedTab || !landing || !carousel || !ticketSlot || !tearTab || !ticketOverview || !ripGlow || !mobileTicket || !mobileFrame || !mobileRipCut) return;
  const mobileStub = section.querySelector('.sale-intro__mobile-stub');
  const mobileOverview = mobileStub.querySelector('.sale-intro__mobile-stub-overview');
  const ticketTopContent = ['.sale-intro__ticket-heading', '.sale-intro__ticket-claim', '.sale-intro__ticket-overview'];
  const ticketBottomContent = ['.sale-intro__ticket-prize', '.sale-intro__ticket-serial', '.sale-intro__barcode-live'];
  const anchoredContent = [
    ...ticketTopContent.map(selector => ({ element: tearTab.querySelector(selector), anchor: 'top' })),
    ...ticketBottomContent.map(selector => ({ element: tearTab.querySelector(selector), anchor: 'bottom' }))
  ].map(item => ({ ...item, left: item.element.offsetLeft, width: item.element.offsetWidth }));

  // Match the curves and half-pixel offset in frame34-ticket.svg exactly.
  // The detached ticket later stretches on its X axis, so reduce only the
  // notch depth by that factor to keep the on-screen holes circular.
  function ticketOutline(lengthFactor = 1) {
    const x = value => (value / lengthFactor).toFixed(3);
    let path = `M ${x(15.02)} 0 H 600 V 600 H ${x(15.02)} L ${x(.01)} 574.01 V 547.98`;
    for (let center = 540.5; center >= 60.5; center -= 30) {
      const y = offset => (center + offset).toFixed(2);
      path += ` C ${x(.18)} ${y(7.47)} ${x(.35)} ${y(7.45)} ${x(.51)} ${y(7.42)}`;
      path += ` C ${x(4.17)} ${y(6.95)} ${x(7.01)} ${y(3.81)} ${x(7.01)} ${y(0)}`;
      path += ` C ${x(7.01)} ${y(-3.81)} ${x(4.17)} ${y(-6.94)} ${x(.51)} ${y(-7.42)}`;
      path += ` C ${x(.35)} ${y(-7.45)} ${x(.18)} ${y(-7.47)} ${x(.01)} ${y(-7.48)}`;
      if (center > 60.5) path += ` V ${y(-22.52)}`;
    }
    return `path("${path} V 25.99 L ${x(15.02)} 0 Z")`;
  }
  attachedTab.querySelector('.sale-intro__ticket-face').style.clipPath = ticketOutline();
  const detachedFace = tearTab.querySelector('.sale-intro__ticket-face');

  const barcodeRanges = '0:4.3858 17.6215:22.0468 26.4332:39.6696 44.0547:57.2912 61.7178:66.1036 70.5277:74.9135 79.3791:83.765 96.9609:110.197 114.624:127.86 132.285:136.671 141.057:154.294 158.758:163.144 176.38:180.766 185.191:189.577 193.963:207.2 211.625:216.05 220.476:224.862 238.058:251.294 255.719:268.956 273.382:277.768 282.192:295.429 299.855:304.241 317.437:321.862 326.288:330.674 335.098:348.335 352.761:357.147 361.532:365.957 379.195:392.431 396.816:410.053 414.477:418.903 423.289:436.526 440.911:445.336 458.574:462.96 467.384:471.809 476.195:489.432 493.857:498.242 511.48:515.905 520.29:533.526 537.913:551.149 555.614:560';
  document.querySelectorAll('.sale-intro__barcode-live').forEach(barcode => {
    barcodeRanges.split(' ').forEach(range => {
      const [top, bottom] = range.split(':').map(Number);
      const stripe = document.createElement('span');
      stripe.style.top = `${top}px`;
      stripe.style.height = `${bottom - top}px`;
      barcode.append(stripe);
    });
  });

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = value => Math.min(1, Math.max(0, value));
  const ease = value => value * value * (3 - 2 * value);
  const mix = (a, b, amount) => a + (b - a) * amount;
  const fallEase = progress => {
    const accelerationEnd = .72;
    if (progress <= accelerationEnd) {
      return .75 * (progress / accelerationEnd) ** 1.7;
    }
    const settle = (progress - accelerationEnd) / (1 - accelerationEnd);
    return .75 + .25 * (1 - (1 - settle) ** 2);
  };
  let frameRequest = 0;
  let mobileCarouselPrepared = false;
  let mobileRipCompletedAt = null;
  let mobileRipDistance = 0;
  let mobileRipLastScrollY = window.scrollY;
  let mobileRipLastScrollAt = 0;
  let mobileRipResetTimer = 0;
  let mobileFallStartScrollY = null;
  let mobileAutoScrollCancelled = false;
  let ripCompletedAt = null;
  let fallStartDocumentY = null;
  let fallStartScrollY = null;
  let autoScrollCancelled = false;
  let initialViewPending = true;
  const fallDelay = 80;
  const fallDuration = 900;
  const expandDelay = 80;
  const expandDuration = 520;
  const mobileRipPause = 220;
  const mobileFallDuration = 900;
  const mobileCopyDelay = 500;

  function positionTicketContent(lengthFactor) {
    detachedFace.style.clipPath = ticketOutline(lengthFactor);
    const inverse = 1 / lengthFactor;
    anchoredContent.forEach(({ element, anchor, left, width }) => {
      const sourceX = left - 1260;
      const nextX = anchor === 'top'
        ? sourceX * inverse
        : 600 - (600 - sourceX - width) * inverse - width;
      element.style.left = `${1260 + nextX}px`;
      element.style.transformOrigin = anchor === 'top' ? 'left center' : 'right center';
      element.style.transform = `scaleX(${inverse})`;
    });
  }

  function showTicketSlotOnMobile() {
    if (mobileCarouselPrepared) return;
    const galleryRect = carousel.getBoundingClientRect();
    const slotRect = ticketSlot.getBoundingClientRect();
    carousel.scrollLeft += slotRect.left - galleryRect.left - (galleryRect.width - slotRect.width) / 2;
    mobileCarouselPrepared = true;
  }

  function getTicketSlotRect(mobile) {
    const rect = ticketSlot.getBoundingClientRect();
    const leftInset = mobile ? 0 : 4; // Match the desktop gallery gutter.
    return { left: rect.left + leftInset, width: rect.width - leftInset, height: rect.height, bottom: rect.bottom };
  }

  function render() {
    frameRequest = 0;
    const width = stage.clientWidth;
    const height = stage.clientHeight;
    const mobile = window.innerWidth <= 720;
    if (!mobile) mobileCarouselPrepared = false;
    if (mobile) {
      mobileStub.style.height = 'auto';
      mobileStub.style.minHeight = `${Math.max(220, mobileTicket.offsetHeight / 2)}px`;
      const ticketRect = mobileTicket.getBoundingClientRect();
      const frameRect = mobileFrame.getBoundingClientRect();
      const seamY = ticketRect.bottom;
      const viewportHeight = window.innerHeight;
      const ripStartY = viewportHeight / 2;
      const ripProgress = seamY <= ripStartY ? clamp(mobileRipDistance / (viewportHeight * .18)) : 0;
      const now = performance.now();
      // Once torn, the stub stays detached even when the page scrolls back up.
      if (ripProgress === 1 && mobileRipCompletedAt === null) {
        mobileRipCompletedAt = now;
        mobileFallStartScrollY = window.scrollY;
        window.clearTimeout(mobileRipResetTimer);
      }
      const visibleRipProgress = mobileRipCompletedAt === null ? ripProgress : 1;
      const fallProgress = mobileRipCompletedAt === null ? 0 : clamp((now - mobileRipCompletedAt) / mobileFallDuration);
      const fallTravel = reducedMotion.matches ? (mobileRipCompletedAt === null ? 0 : 1) : fallEase(fallProgress);
      const drop = 250 * fallTravel;
      const hasFallen = fallTravel >= 1;
      const copyVisible = hasFallen && (reducedMotion.matches || now - mobileRipCompletedAt >= mobileFallDuration + mobileCopyDelay);
      mobileStub.classList.toggle('is-fallen', hasFallen);
      mobileStub.classList.toggle('is-copy-visible', copyVisible);
      mobileStub.setAttribute('aria-hidden', String(!hasFallen));
      mobileOverview.setAttribute('aria-hidden', String(!copyVisible));
      const tearTension = reducedMotion.matches || mobileRipCompletedAt !== null ? 0 : 7 * Math.sin(Math.PI * ripProgress);
      mobileStub.style.transform = `translateY(${drop + tearTension}px)`;
      // Close the original 112px gap as the stub falls, ending flush with the photo.
      stage.style.setProperty('--mobile-drop-space', `${drop - 112 * fallTravel}px`);
      if (mobileFallStartScrollY !== null && !mobileAutoScrollCancelled && !reducedMotion.matches && fallProgress < 1) {
        const scrollTravel = fallEase(clamp((fallProgress - .08) / .92));
        const nextScrollY = Math.max(window.scrollY, mobileFallStartScrollY + 135 * scrollTravel);
        if (nextScrollY > window.scrollY + .5) window.scrollTo({ top: nextScrollY, behavior: 'instant' });
      }

      // Reveal the tear across the perforated edge before the stub can fall.
      mobileRipCut.style.left = `${ticketRect.left - frameRect.left}px`;
      mobileRipCut.style.top = `${seamY - frameRect.top - 2}px`;
      mobileRipCut.style.width = `${ticketRect.width * visibleRipProgress}px`;
      mobileRipCut.style.opacity = reducedMotion.matches ? '0' : String(clamp(1 - fallProgress * 3));
      const glowX = ticketRect.left + ticketRect.width * visibleRipProgress;
      const snapAge = mobileRipCompletedAt === null ? 160 : now - mobileRipCompletedAt;
      const snapFlash = snapAge < 160;
      const completionGlow = mobileRipCompletedAt === null ? 1 : clamp(1 - snapAge / 320);
      const glow = reducedMotion.matches || visibleRipProgress === 0 ? 0 : snapFlash ? 1 - snapAge / 160 : completionGlow * (.65 + .35 * Math.sin(Math.PI * visibleRipProgress));
      ripGlow.style.left = `${snapFlash ? ticketRect.left : glowX - 40}px`;
      ripGlow.style.top = `${seamY - 24}px`;
      ripGlow.style.width = snapFlash ? `${ticketRect.width}px` : '80px';
      ripGlow.style.height = '48px';
      ripGlow.style.opacity = String(glow);
      if (mobileRipCompletedAt !== null && !copyVisible) scheduleRender();
      landing.classList.add('is-prize-revealed');
      tearTab.classList.remove('is-settled');
      tearTab.setAttribute('aria-hidden', 'true');
      tearTab.style.opacity = '0';
      return;
    }
    let frameScale = 1;
    let frameX = 0;
    let frameY = 0;

    if (!mobile) {
      frameScale = Math.min(width / 1920, height / 640);
      frameX = (width - 1920 * frameScale) / 2;
      frameY = (height - 640 * frameScale) / 2;
      frame.style.transform = `translate(${frameX}px, ${frameY}px) scale(${frameScale})`;
    }

    if (reducedMotion.matches) {
      if (mobile) showTicketSlotOnMobile();
      const photoRect = getTicketSlotRect(mobile);
      const landingRect = landing.getBoundingClientRect();
      const settledScale = photoRect.width / tearTab.offsetHeight;
      const lengthFactor = photoRect.height / photoRect.width;
      tearTab.style.left = `${photoRect.left - landingRect.left + photoRect.width / 2}px`;
      tearTab.style.top = `${photoRect.bottom - landingRect.top - photoRect.height / 2}px`;
      tearTab.style.transform = `translate(-50%, -50%) rotate(90deg) scale(${settledScale * lengthFactor}, ${settledScale})`;
      positionTicketContent(lengthFactor);
      ticketOverview.style.opacity = '1';
      ticketOverview.setAttribute('aria-hidden', 'false');
      tearTab.style.filter = 'drop-shadow(0 4px 8px rgba(0, 0, 0, .16))';
      ripGlow.style.opacity = '0';
      tearTab.classList.add('is-settled');
      tearTab.setAttribute('aria-hidden', 'false');
      landing.classList.add('is-prize-revealed');
      return;
    }

    const sectionRect = section.getBoundingClientRect();
    const scrollPast = -sectionRect.top;
    const ripStart = height * .18;
    const ripEnd = height * .93;
    const ripProgress = clamp((scrollPast - ripStart) / (ripEnd - ripStart));
    const now = performance.now();
    // A browser-restored scroll position should show the completed ticket immediately.
    if (initialViewPending && window.scrollY >= landing.offsetTop - height * .25) {
      ripCompletedAt = now - fallDelay - fallDuration - expandDelay - expandDuration;
      autoScrollCancelled = true;
      landing.classList.add('is-initially-settled');
    }
    if (ripProgress >= 1 && ripCompletedAt === null) ripCompletedAt = now;
    const hasRipped = ripCompletedAt !== null;
    const fallProgress = hasRipped ? clamp((now - ripCompletedAt - fallDelay) / fallDuration) : 0;
    const expandProgress = hasRipped ? clamp((now - ripCompletedAt - fallDelay - fallDuration - expandDelay) / expandDuration) : 0;
    if (mobile && hasRipped) showTicketSlotOnMobile();
    landing.classList.toggle('is-prize-revealed', expandProgress >= 1);

    const isRipping = scrollPast > ripStart;
    const tearLine = hasRipped ? 600 : 600 * clamp(ripProgress + Math.sin(ripProgress * 34) * .006 * (1 - ripProgress));
    const overlap = hasRipped ? 0 : 24 * Math.sin(Math.PI * ripProgress);
    attachedTab.style.clipPath = mobile ? 'none' : `inset(${Math.max(0, tearLine - overlap)}px 0 0 0)`;
    tearTab.style.clipPath = mobile || hasRipped ? 'none' : `inset(0 0 ${Math.max(0, 600 - tearLine - overlap)}px 0)`;
    const glowIn = Math.min(1, ripProgress * 10);
    const glowOut = hasRipped ? 1 - ease(clamp((now - ripCompletedAt) / 320)) : 1;
    ripGlow.style.opacity = !mobile && isRipping ? String(hasRipped ? glowOut : glowIn) : '0';
    if (hasRipped && (glowOut > 0 || fallProgress < 1 || expandProgress < 1)) scheduleRender();
    ripGlow.style.left = `${frameX + 1260 * frameScale - 24 * frameScale}px`;
    ripGlow.style.top = `${frameY + 20 * frameScale}px`;
    ripGlow.style.width = `${48 * frameScale}px`;
    ripGlow.style.height = `${600 * frameScale}px`;
    ripGlow.style.setProperty('--rip-y', `${tearLine * frameScale}px`);
    section.classList.toggle('is-torn', mobile && hasRipped);
    const landingVisible = landing.getBoundingClientRect().bottom > 0;
    const settled = fallProgress >= 1 && landingVisible && scrollPast >= ripEnd;
    tearTab.classList.toggle('is-settled', settled);
    tearTab.setAttribute('aria-hidden', String(!settled));
    tearTab.style.opacity = (mobile ? hasRipped : isRipping) && landingVisible && (!hasRipped || scrollPast >= ripEnd) ? '1' : '0';
    if (!isRipping && !hasRipped) return;

    const mobileRect = mobileTicket.getBoundingClientRect();
    const startX = mobile ? mobileRect.left + mobileRect.width / 2 : frameX + 1560 * frameScale;
    const startY = mobile ? mobileTicket.offsetTop + mobileTicket.offsetHeight / 2 : frameY + 320 * frameScale;
    if (hasRipped && fallStartDocumentY === null) {
      fallStartDocumentY = startY + window.scrollY;
      fallStartScrollY = window.scrollY;
    }
    const startScale = mobile ? Math.min(mobileRect.width / 600, mobileRect.height / 600) : frameScale;
    const photoRect = getTicketSlotRect(mobile);
    const destinationX = photoRect.left + photoRect.width / 2;
    const endScale = photoRect.width / tearTab.offsetHeight;
    const destinationY = photoRect.bottom - tearTab.offsetHeight * endScale / 2;
    const destinationDocumentY = destinationY + window.scrollY;
    const travel = fallEase(fallProgress);
    if (hasRipped && fallProgress < 1 && !autoScrollCancelled) {
      const photoBottomDocumentY = photoRect.bottom + window.scrollY;
      const maxScrollY = document.documentElement.scrollHeight - window.innerHeight;
      const targetScrollY = Math.min(maxScrollY, Math.max(fallStartScrollY, photoBottomDocumentY - (window.innerHeight + photoRect.height) / 2));
      const scrollTravel = fallEase(clamp((fallProgress - .08) / .92));
      const nextScrollY = Math.max(window.scrollY, mix(fallStartScrollY, targetScrollY, scrollTravel));
      if (nextScrollY > window.scrollY + .5) window.scrollTo({ top: nextScrollY, behavior: 'instant' });
    }
    const separation = mobile ? 0 : 8 * ease(hasRipped ? 1 : ripProgress);
    const release = ease(clamp(fallProgress / .14));
    const spin = fallEase(clamp((fallProgress - .1) / .83));
    const angularSettle = 1.5 * Math.sin(Math.PI * clamp((fallProgress - .88) / .12));
    const rotation = 4 * release + 86 * spin + angularSettle;
    const hingeWeight = 1 - ease(clamp((fallProgress - .08) / .18));
    const hingeAngle = 4 * release * Math.PI / 180;
    const hingeRadius = tearTab.offsetWidth * startScale / 2;
    const hingeX = hingeWeight * hingeRadius * (Math.cos(hingeAngle) - 1);
    const hingeY = hingeWeight * hingeRadius * Math.sin(hingeAngle);
    const drift = (mobile ? 10 : 22) * Math.sin(Math.PI * travel) * (1 - .25 * travel);
    const centerX = fallProgress > 0
      ? mix(startX + separation, destinationX, travel) + drift + hingeX
      : startX + separation;
    const centerY = fallProgress > 0
      ? mix(fallStartDocumentY, destinationDocumentY, travel) + hingeY - window.scrollY
      : hasRipped ? fallStartDocumentY - window.scrollY : startY;
    const sizeProgress = ease(clamp((fallProgress - .1) / .82));
    const scale = fallProgress > 0
      ? mix(startScale, endScale, sizeProgress)
      : startScale;
    const lengthFactor = mix(1, photoRect.height / photoRect.width, ease(expandProgress));
    positionTicketContent(lengthFactor);
    ticketOverview.style.opacity = String(ease(clamp((expandProgress - .55) / .35)));
    ticketOverview.setAttribute('aria-hidden', String(expandProgress < .75));
    tearTab.style.left = `${centerX}px`;
    tearTab.style.top = `${centerY - photoRect.width * (lengthFactor - 1) / 2}px`;
    tearTab.style.transform = `translate(-50%, -50%) rotate(${rotation}deg) scale(${scale * lengthFactor}, ${scale})`;
    const shadowLift = ease(clamp(fallProgress / .12));
    const shadowBlur = mix(24, 8, travel);
    const shadowY = mix(17, 4, travel);
    const shadowOpacity = mix(0, mix(.12, .16, travel), shadowLift);
    tearTab.style.filter = `drop-shadow(0 ${shadowY}px ${shadowBlur}px rgba(0, 0, 0, ${shadowOpacity}))`;
  }

  function scheduleRender() {
    if (!frameRequest) frameRequest = requestAnimationFrame(render);
  }

  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    if (window.innerWidth <= 720 && mobileRipCompletedAt === null) {
      const delta = scrollY - mobileRipLastScrollY;
      const ripStartScrollY = mobileTicket.getBoundingClientRect().bottom + scrollY - window.innerHeight / 2;
      if (scrollY < ripStartScrollY || delta < 0) {
        mobileRipDistance = 0;
        mobileRipLastScrollAt = 0;
        window.clearTimeout(mobileRipResetTimer);
      } else if (delta > 0) {
        const now = performance.now();
        if (mobileRipLastScrollAt && now - mobileRipLastScrollAt > mobileRipPause) mobileRipDistance = 0;
        mobileRipDistance += scrollY - Math.max(mobileRipLastScrollY, ripStartScrollY);
        mobileRipLastScrollAt = now;
        window.clearTimeout(mobileRipResetTimer);
        mobileRipResetTimer = window.setTimeout(() => {
          if (mobileRipCompletedAt !== null) return;
          mobileRipDistance = 0;
          mobileRipLastScrollAt = 0;
          scheduleRender();
        }, mobileRipPause);
      }
    }
    mobileRipLastScrollY = scrollY;
    scheduleRender();
  }, { passive: true });
  window.addEventListener('wheel', event => {
    if (ripCompletedAt !== null && event.deltaY < 0) autoScrollCancelled = true;
    if (mobileRipCompletedAt !== null && event.deltaY < 0) mobileAutoScrollCancelled = true;
  }, { passive: true });
  window.addEventListener('touchstart', () => {
    if (ripCompletedAt !== null) autoScrollCancelled = true;
    if (mobileRipCompletedAt !== null) mobileAutoScrollCancelled = true;
  }, { passive: true });
  carousel.addEventListener('scroll', scheduleRender, { passive: true });
  window.addEventListener('resize', scheduleRender);
  new ResizeObserver(scheduleRender).observe(mobileTicket);
  reducedMotion.addEventListener('change', scheduleRender);
  window.addEventListener('pageshow', () => {
    requestAnimationFrame(() => requestAnimationFrame(() => {
      render();
      initialViewPending = false;
    }));
  });
  document.fonts?.ready.then(scheduleRender);
  render();
})();
